const renderProduct = async (productEmbedEl) => {
  const productHandle = productEmbedEl.dataset.lrEmbedProduct;

  try {
    const url = `/products/${productHandle}?view=grid-item`;
    const res = await fetch(url);
    if (!res.ok) {
      return;
    }
    const html = await res.text();

    productEmbedEl.innerHTML = html;
    productEmbedEl.classList.add('embedded-product-wrapper');
  } catch (err) {
    console.error(`Error embedding product with handle ${this.productHandle}`);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  const productEmbedEls = document.querySelectorAll('[data-lr-embed-product]');

  productEmbedEls.forEach(el => renderProduct(el));
});